import { EventEmitter, Injectable, Output } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CalendarEvent } from "../_types/calendar-event";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})

export class CalendarsEventsService extends Service<CalendarEvent> {
  public override type = 'calendarsEvents';
  public override url = 'providers/calendarEvents';
  

  public saveCalendarEventsRange(calendarId: string, calendarEventsRange: any): Observable<void> {
    let url = this.getAPIUrl() + "/" + calendarId + '/saveCalendarEventsRange';
    return this.http.post<void>(url, calendarEventsRange);
  }

  public deleteCalendarEventsRange(calendarId: string, calendarEventsRange: any): Observable<void> {
    let url = this.getAPIUrl() + "/" + calendarId + '/deleteCalendarEventsRange';
    return this.http.post<void>(url, calendarEventsRange);
  }
}
